import _regeneratorRuntime from "/Users/seva/Developer/strategy_master/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _classCallCheck from "/Users/seva/Developer/strategy_master/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/seva/Developer/strategy_master/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/seva/Developer/strategy_master/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/seva/Developer/strategy_master/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/Users/seva/Developer/strategy_master/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import { Indicator } from "../indicator/indicator";
import { LinkedList } from "../Utils/LinkedList"; // STEP3. Add class based syntax with export

export var WilderSmoothing =
/*#__PURE__*/
function (_Indicator) {
  _inherits(WilderSmoothing, _Indicator);

  function WilderSmoothing(input) {
    var _this;

    _classCallCheck(this, WilderSmoothing);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(WilderSmoothing).call(this, input));
    _this.period = input.period;
    _this.price = input.values;

    var genFn =
    /*#__PURE__*/
    _regeneratorRuntime.mark(function genFn(period) {
      var list, sum, counter, current, result;
      return _regeneratorRuntime.wrap(function genFn$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              list = new LinkedList();
              sum = 0;
              counter = 1;
              _context.next = 5;
              return;

            case 5:
              current = _context.sent;
              result = 0;

            case 7:
              if (!true) {
                _context.next = 14;
                break;
              }

              if (counter < period) {
                counter++;
                sum = sum + current;
                result = undefined;
              } else if (counter === period) {
                counter++;
                sum = sum + current;
                result = sum;
              } else {
                result = result - result / period + current;
              }

              _context.next = 11;
              return result;

            case 11:
              current = _context.sent;
              _context.next = 7;
              break;

            case 14:
            case "end":
              return _context.stop();
          }
        }
      }, genFn);
    });

    _this.generator = genFn(_this.period);

    _this.generator.next();

    _this.result = [];

    _this.price.forEach(function (tick) {
      var result = _this.generator.next(tick);

      if (result.value !== undefined) {
        _this.result.push(_this.format(result.value));
      }
    });

    return _this;
  }

  _createClass(WilderSmoothing, [{
    key: "nextValue",
    value: function nextValue(price) {
      var result = this.generator.next(price).value;

      if (result !== undefined) {
        return this.format(result);
      }
    }
  }]);

  return WilderSmoothing;
}(Indicator);
WilderSmoothing.calculate = wildersmoothing;
export function wildersmoothing(input) {
  Indicator.reverseInputs(input);
  var result = new WilderSmoothing(input).result;

  if (input.reversedInput) {
    result.reverse();
  }

  Indicator.reverseInputs(input);
  return result;
} // STEP 6. Run the tests